import React from 'react';

export default function ProductSwitcher(props) {
  const switcherItems = [];
  for (let i = 1; i < 3; i++) {
    if (props.metafields.parentSelector[`handle_${i}`]) {
      switcherItems.push({'handle': props.metafields.parentSelector[`handle_${i}`], 'label': props.metafields.parentSelector[`text_${i}`]})
    }
  }

  const _changeProduct = (e, newProduct) => {
    e.preventDefault();
    props.onProductChange(newProduct, props.currentVariant);
  }

  let showElement = true;
  if (props.product.tags.includes('param_selector') && !props.url.searchParams.has('param_selector')) {
    showElement = false;
  }

  const paramSelector = props.product.tags.includes('param_selector') && props.url.searchParams.has('param_selector');
  let className = 'option-wrapper option-handle-width option-add-selector';
  if (paramSelector) {
    className += ' param-selector';
  }

  if (showElement && switcherItems.length > 0) {
    return(
      <div className={`${className}`}>
        <div className="option-header">
          <span className="option-name">
            {props.metafields.parentSelector.title}:
          </span>
        </div>
        <div className="option-values">
          {switcherItems.map((product, i) => {
            return <div className={product.handle === props.product.handle ? 'option-value selected' : 'option-value'} key={i}>
              <a href={`/products/${product.handle}`} onClick={e => _changeProduct(e, product)}>
                <span className="option-value-name">
                  <span className="option-value-inner">
                    {product.label}
                  </span>
                </span>
              </a>
            </div>
          })}
        </div>
      </div>
    )
  }

  return (null);
}